import LanguageCreate from './LanguageCreate'

export default LanguageCreate
